export default "__VITE_ASSET__DhVGFXqu__"